// extracted by mini-css-extract-plugin
export default {"menu":"consignees_menu__APFOK","searchWrap":"consignees_searchWrap__n3vpz","searchLabel":"consignees_searchLabel__MJcCq"};